// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__162xz","rootNoMargin":"styles_rootNoMargin__UGKY7"};